export const MOBILE_DESCRIPTION_LENGTH = 60;
